var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finish"},[_c('img',{ref:"img",attrs:{"src":require("../assets/c.png")}}),_vm._v(" "),_c('p',{staticClass:"success-text"},[_vm._v("新密码设置成功！")]),_vm._v(" "),_c('el-button',{staticClass:"to-login",attrs:{"type":"primary"},on:{"click":_vm.next}},[_vm._v("立即登录")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25d74b36","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/forgetPassword/finish.vue
// module id = null
// module chunks = 